import React from 'react';

function SecureIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="18"
            fill="none"
            viewBox="0 0 13 18"
            {...props}
        >
            <g clipPath="url(#clip0_1333_16904)">
                <path
                    stroke="#000"
                    strokeWidth="0.9"
                    d="M10.138 7.428v.45h1.294c.52 0 .975.448.975 1.04v7.455c0 .593-.455 1.04-.975 1.04H1.425c-.52 0-.975-.448-.975-1.04V8.918c0-.594.455-1.04.975-1.04H2.72V4.478c0-1.785 1.616-3.308 3.71-3.308 2.092 0 3.71 1.524 3.71 3.307v2.951zm-6.806 0v.45h6.194V4.478c0-1.526-1.42-2.717-3.097-2.717-1.679 0-3.097 1.19-3.097 2.716v2.951zm3.097 3.116c-.664 0-1.207.53-1.207 1.195v2.237c0 .67.548 1.195 1.207 1.195.664 0 1.206-.53 1.206-1.195v-2.237c0-.67-.548-1.195-1.206-1.195z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_1333_16904">
                    <path fill="#fff" d="M0 0H12.857V18H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default SecureIcon;
